import { FilterDocument } from '@griply/types';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';

import { Interactions } from './interactions';
import * as Styled from './page-top-bar.style';

export type PageTopBarProps = {
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
};

export const PageTopBar: React.FC<PageTopBarProps> = ({
  filterDocument,
  setFilterDocument,
}) => {
  const { t } = useTranslation();

  return (
    <TopBarBase>
      <Styled.Content>
        <Styled.Title>
          <Typography variant="h5" component="h1">
            {t('pages.completed.title')}
          </Typography>
        </Styled.Title>

        <Interactions
          filterDocument={filterDocument}
          setFilterDocument={setFilterDocument}
        />
      </Styled.Content>
    </TopBarBase>
  );
};
